const REGION_CONFIG = {
  AT: {
    siteUrl: "https://pro.autoeinfachlos.at",
    customerSiteUrl: "https://www.autoeinfachlos.at",
    backendUrl: "https://ael-backend-main-402643550069.europe-west3.run.app/api",
    supportEmail: "pro@autoeinfachlos.at",
    serviceEmail: "service@autoeinfachlos.at",
    billingEmail: "abrechnung@autoeinfachlos.at",
    countryName: "Österreich",
    countryAdjective: "österreichische",
    mapsRegion: "AT",
    appStoreUrl:
      "https://apps.apple.com/at/app/autoeinfachlos-pro/id6759858647#information",
    playStoreUrl:
      "https://play.google.com/store/apps/details?id=pro.autoeinfachlos.at",
  },
  DE: {
    siteUrl: "https://pro.autoeinfachlos.de",
    customerSiteUrl: "https://www.autoeinfachlos.de",
    backendUrl:
      "https://ael-backend-deutschland-698851026171.europe-west3.run.app/api",
    supportEmail: "pro@autoeinfachlos.de",
    serviceEmail: "service@autoeinfachlos.de",
    billingEmail: "abrechnung@autoeinfachlos.de",
    countryName: "Deutschland",
    countryAdjective: "deutsche",
    mapsRegion: "DE",
    appStoreUrl: null,
    playStoreUrl: null,
  },
};

const ENV_BACKEND_URLS = {
  LOCAL: "http://localhost:8001/api",
  DEV: "https://ael-backend-development-402643550069.europe-west3.run.app/api",
  STAGING: "https://ael-backend-staging-402643550069.europe-west3.run.app/api",
};

const ENV_SITE_URLS = {
  LOCAL: "http://localhost:3000",
  DEV: "https://dev-ael-auktion.vercel.app",
  STAGING: "https://ael-auktion-staging.vercel.app",
};

const REGION_STATES = {
  AT: [
    "Wien",
    "Niederösterreich",
    "Oberösterreich",
    "Steiermark",
    "Tirol",
    "Vorarlberg",
    "Salzburg",
    "Kärnten",
    "Burgenland",
  ],
  DE: [
    "Baden-Württemberg",
    "Bayern",
    "Berlin",
    "Brandenburg",
    "Bremen",
    "Hamburg",
    "Hessen",
    "Mecklenburg-Vorpommern",
    "Niedersachsen",
    "Nordrhein-Westfalen",
    "Rheinland-Pfalz",
    "Saarland",
    "Sachsen",
    "Sachsen-Anhalt",
    "Schleswig-Holstein",
    "Thüringen",
  ],
};

function normalizeEnv(value) {
  return String(value || "MAIN").trim().toUpperCase();
}

function normalizeRegion(value) {
  const region = String(value || "AT").trim().toUpperCase();
  return region === "DE" ? "DE" : "AT";
}

function stripTrailingSlash(value) {
  return String(value || "").replace(/\/+$/, "");
}

export function getRegion() {
  return normalizeRegion(process.env.NEXT_PUBLIC_REGION);
}

export function isGermanyRegion() {
  return getRegion() === "DE";
}

export function getRegionConfig() {
  return REGION_CONFIG[getRegion()];
}

export function getSiteUrl() {
  const configuredUrl = process.env.NEXT_PUBLIC_SITE_URL;
  if (configuredUrl) return stripTrailingSlash(configuredUrl);

  const env = normalizeEnv(process.env.NEXT_PUBLIC_ENV);
  if (ENV_SITE_URLS[env]) return ENV_SITE_URLS[env];

  return REGION_CONFIG[getRegion()].siteUrl;
}

export function getCustomerSiteUrl() {
  return stripTrailingSlash(
    process.env.NEXT_PUBLIC_CUSTOMER_SITE_URL ||
      REGION_CONFIG[getRegion()].customerSiteUrl
  );
}

export function getCanonicalUrl(path = "", options = {}) {
  const baseUrl = options.customer ? getCustomerSiteUrl() : getSiteUrl();
  const normalizedPath = path ? `/${String(path).replace(/^\/+/, "")}` : "";
  return `${baseUrl}${normalizedPath}`;
}

export function getBackendApiUrl() {
  const configuredUrl =
    process.env.NEXT_PUBLIC_BACKEND_URL || process.env.BACKEND_URL;
  if (configuredUrl) return stripTrailingSlash(configuredUrl);

  const env = normalizeEnv(process.env.NEXT_PUBLIC_ENV);
  if (ENV_BACKEND_URLS[env]) return ENV_BACKEND_URLS[env];

  return REGION_CONFIG[getRegion()].backendUrl;
}

export function getBackendRootUrl() {
  return getBackendApiUrl().replace(/\/api$/, "");
}

export function getGoogleMapsRegion() {
  return process.env.NEXT_PUBLIC_GOOGLE_MAPS_REGION || getRegionConfig().mapsRegion;
}

export function getSupportEmail() {
  return process.env.NEXT_PUBLIC_SUPPORT_EMAIL || getRegionConfig().supportEmail;
}

export function getServiceEmail() {
  return process.env.NEXT_PUBLIC_SERVICE_EMAIL || getRegionConfig().serviceEmail;
}

export function getBillingEmail() {
  return process.env.NEXT_PUBLIC_BILLING_EMAIL || getRegionConfig().billingEmail;
}

export function getMarketCountryName() {
  return getRegionConfig().countryName;
}

export function getMarketCountryAdjective() {
  return getRegionConfig().countryAdjective;
}

export function getAppStoreLinks() {
  const { appStoreUrl, playStoreUrl } = getRegionConfig();
  return { appStoreUrl, playStoreUrl };
}

export function getRegionStates() {
  return REGION_STATES[getRegion()];
}

function normalizeStateSearchText(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/ä/g, "ae")
    .replace(/ö/g, "oe")
    .replace(/ü/g, "ue")
    .replace(/ß/g, "ss")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function normalizeMarketState(value) {
  if (!value || typeof value !== "string") return null;
  const normalizedValue = normalizeStateSearchText(value);
  const states = getRegionStates();

  return (
    states.find((state) => {
      const normalizedState = normalizeStateSearchText(state);
      return (
        normalizedValue === normalizedState ||
        normalizedValue.includes(normalizedState)
      );
    }) || null
  );
}
